import React from "react";

export default () => (
    <svg
        width="19"
        height="30"
        viewBox="0 0 19 30"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g id="Smart-TV-UI" fill="none" fillRule="evenodd">
            <g
                id="Demo-v3---default"
                transform="translate(-53 -895)"
                fill="currentColor"
            >
                <path
                    d="M53.4350288,921.464466 L64.8994949,910 L53.4350288,898.535534 L56.9705627,895 L71.9705627,910 L56.9705627,925 L53.4350288,921.464466 Z"
                    id="Combined-Shape"
                />
            </g>
        </g>
    </svg>
);



// WEBPACK FOOTER //
// ./src/components/icons/chevron.js